import type { FaireProductEntity } from "../../entity_types/product";

export const p_bcgbx4yf9s: FaireProductEntity = {
  token: "p_bcgbx4yf9s",
  type: "product",
  name: "Archtoad of Hatville Crew Socks",
  brandToken: "b_dskill7gu0",
  brandName: "FootClothes LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/a6eb6bc12a79833ea6ef1fbfbe5bf3f3bf27b6d53c19e737069e46994e7b7a7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c631c5bd918e3b232909fa97415a24f04645fb306e4f88975eb1e8f499325b6.jpeg",
    "https://cdn.faire.com/fastly/bfa55afe178226e8e226d687fcba3d1fa27c31e46b207664a333064a2272e738.jpeg",
    "https://cdn.faire.com/fastly/1ff7d2b658cff3cef86ce6d0df5a11ac31daad77f08a9b11dcfd99dbf012e5d2.jpeg",
    "https://cdn.faire.com/fastly/958f6c7ac6f5af9f7af7c8c757bc33bc9b37aaa7d6c6fec65f6800494575694e.jpeg",
    "https://cdn.faire.com/fastly/5fcde1d403eec4b081a6744d04bfea8888a8d466289c1fa1d663ee3be640d3f7.jpeg",
    "https://cdn.faire.com/fastly/241f7fac9080c266e92fdf43882164abc3ef271f95d99b46d342f0574ff3b1c7.jpeg",
    "https://cdn.faire.com/fastly/4c5fc40de3df3b4157fb4b4c63e96f529523b9e3b1575518d1845aa0681d4f06.png",
    "https://cdn.faire.com/fastly/087f255a576009cf9c093e96c4c6cff62958d7e3b8a9a556fe2db9558f8f4be0.png",
  ],
  priceDollars: 6,
  description:
    "As the Archtoad of Hatville, I decree you are worthy of spending a day doing nothing but looking cute. Mushroom optional. I understand those don't readily come in sizes appropriate for human seating. Shame.\n\n-------\n\n𝗦𝗼𝗰𝗸 𝗦𝗽𝗲𝗰𝘀:\n\n• Combed Cotton/Nylon/Spandex for breathability, durability, and stretch\n• Double terry in the heel and toe area adds durability and comfort where most novelty sock brands fail.\n• 200N Thread Count for highest level of detail\n• 40 Gram Socks with smooth seams\n• No uncomfortable bumps in the toe area\n• One Size Fits Most Humans Size 6-13, may be snug on wider calves",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:38.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
